<template>
  <div class="PA-submit">
    <div @submit.prevent="handleSubmit()" class="body">
      <form @submit.prevent ref="form">
        <h2>Ablage Informationen</h2>
        <section>
          <h3>Student Informationen</h3>
          <SelectAsyncElement ref="async_student" :readonly="false" :required="true" name="student" @change="handleStudentSelect" :getOptionDisplayValue="getStudentDisplayValue" label="Student auswählen" tooltip="Wähle einen Studenten um Informationen automatisch auszufüllen" url="https://www-3.mach.kit.edu/api/public/index.php/api/student" data_name="students" :getOptionName="getStudentName"/>
          <div class="subsection">
            <InputElement :readonly="true" ref="input_vorname" :required="true" label="Vorname" name="Vorname"/>
            <InputElement :readonly="true" ref="input_nachname" :required="true" label="Nachname" name="Nachname"/>
          </div >
          <div class="subsection">
            <InputElement :readonly="true" ref="input_matrnr" :required="true" label="Matrikelnummer" name="MatrNr"/>
            <InputElement :readonly="true" ref="input_email" :required="true" label="E-Mail" name="E-Mail"/>
          </div>
        </section>
        <section>
          <h3>Dokument Informationen</h3>
          <div class="subsection">
            <SelectElement :data="ablage_types" class="cols-2" :required="true" label="Typ" name="type" ref="type"/>
            <InputElement  :required="true" class="cols-2" label="Kurzbeschreibung" name="beschreibung" ref="beschreibung"/>
            <InputElement type="date" :required="true" class="cols-2" label="Datum" name="date" ref="date"/>

          </div>
        </section>
        <input type="hidden" :value="file?JSON.stringify(file.fragments):NULL" name="file" >
        <Button label="Submit" :loading="submit_loading"/>
        <div v-if="response_message">File stored as: {{response_message}}</div>
      </form>
    </div>
  </div>
</template>

<script>
import SelectAsyncElement from '@/components/inputs_23/SelectAsyncElement.vue'
import InputElement from '@/components/inputs_23/InputElement.vue'
import SelectElement from '@/components/inputs_23/SelectElement.vue'
import Button from '@/components/inputs_23/Button.vue'
import axios from "axios";

export default {
  name: 'PASubmit',
  components: {
    SelectAsyncElement,
    InputElement,
    SelectElement,
    Button,
  },
  props: {
    file: Object,
  },
  data() {
    return {
      submit_loading: false,
      ablage_types: [
        {id:0,name:"FVL_Studium"},
        {id:1,name:"FVL_AA"},
        {id:2,name:"FVL_Prüfung"},
        {id:3,name:"FVL_Praktikum"},
        {id:4,name:"ZWA"},
        {id:5,name:"ZWA_Präsi"},
        {id:6,name:"Studienverlauf"},
        {id:7,name:"Verbuchung"},
        {id:8,name:"Schwerpunkt"},
        {id:9,name:"Zulassung_Prüfung"},
        {id:10,name:"Prüfung"},
        {id:11,name:"Beratung"},    
        {id:12,name:"Anerkennung"},
        {id:13,name:"Sonstiges"},
        {id:14,name:"Bafög"},
        {id:15,name:"Modulwechsel"},
        {id:16,name:"AA"},
        {id:17,name:"Wechsel_VT"},
      ],
      response_message:null,
    }
  },
  methods: {
    clearForm() {
        this.$refs.input_vorname.clear()
        this.$refs.input_nachname.clear()
        this.$refs.input_matrnr.clear()
        this.$refs.input_email.clear()
        this.$refs.async_student.clear()
        this.$refs.date.clear()
        this.$refs.type.clear()
        this.$refs.beschreibung.clear()
    },
    async handleSubmit() {
      console.log(this.file)
      this.submit_loading = true
      const formData = new FormData(this.$refs.form)
      const request_header = {method:'post',url:this.$store.getters.getApiUrl+`ablage/pa`,data:formData}
      const {data,error} = await axios(request_header).catch(error=>{return {data:null, error}})
      console.log(data,error?.response)
      this.submit_loading = false
      if(error) {
        return
      }
      this.clearForm()
      this.response_message = data.fragment
    },
    handleStudentSelect(student) {
      if(!student) {
        this.$refs.input_vorname.clear()
        this.$refs.input_nachname.clear()
        this.$refs.input_matrnr.clear()
        this.$refs.date.clear()

        this.$refs.input_email.clear()
        return
      }
      this.$refs.input_vorname.setValue(student.Vorname)
      this.$refs.input_nachname.setValue(student.Nachname)
      this.$refs.input_matrnr.setValue(student.MatrNr)
      this.$refs.input_email.setValue(student['E-Mail'])
      console.log(student)
    },
    getStudentDisplayValue(student) {
      return `Name: ${student.Vorname} ${student.Nachname} | MatrNr: ${student.MatrNr} | Stg: ${student.Stg}`
    },
    getStudentName(student) {
      return `
        <div style="display:grid;grid-template-columns:1fr 8rem;">
          <div>
            <span style="font-weight:bold;">
              Name: 
            </span>
            <span>
              ${student.Vorname} ${student.Nachname}
            </span>
          </div>
          <div>
            <span style="font-weight:bold;">
              MatrNr: 
            </span>
            <span>
              ${student.MatrNr}
            </span>
          </div>
          <div>
            <span style="font-weight:bold;">
              Stg: 
            </span>
            <span>
              ${student['Stg Name']}
            </span>
          </div>
        </div>
      `
    }
  }
          // <div style="grid-column-start:1;grid-column-end:3;">

}
</script>


<style scoped lang="scss">
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.PA-submit {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid $text_dark;
  border-radius: 4px;
}
.body {
  width: 100%;
  max-width: 210mm;
}
.subsection {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.cols-2 {
  grid-column-start: 1;
  grid-column-end: 3;
}
</style>
